//	Externals
import React, { useState, useEffect } from "react";
import styles from "./ButtonLoader.module.css";

/*******************
@Purpose : Used for button loader with smooth transitions
@Parameter : {}
@Author : INIC
******************/
export const ButtonLoader = () => {
  const [isWeb, setIsWeb] = useState(true);

  useEffect(() => {
    if (window.screen.width < 1640) {
      setIsWeb(false);
    } else {
      setIsWeb(true);
    }   
  }, [isWeb]);


  return (
    <div className="w-[5.75rem] h-[3rem] p-[.3125rem] flex items-center justify-center bg-gray-800 rounded">
      <svg 
        className={styles.loader} 
        viewBox="0 0 50 50"
        style={{
          width: isWeb ? '28px' : '26px',
          height: isWeb ? '28px' : '26px'
        }}
      >
        <circle cx="25" cy="25" r="20" />
      </svg>
    </div>
  );
};
